'use strict';
const angular = require('angular');

export class AccountLookupComponent {
  /*@ngInject*/
  constructor(SettingsService) {
    this.SettingsService = SettingsService;

    this.flattedAccounts = [];

    this.SettingsService.getByName({name: "chart-of-accounts"}, coa => {
      this.coa = coa.data;

      this.coa.forEach(headAccount => {
        this.flattedAccounts.push({
          code: headAccount.code,
          accounts: headAccount.account,
          description: headAccount.description
        });

        if (headAccount.hasOwnProperty('subAccounts')) {
          headAccount.subAccounts.forEach(subAccount => {

            let accounts = [headAccount.account, subAccount.account].join(':');

            this.flattedAccounts.push({
              code: subAccount.code,
              accounts: accounts,
              description: subAccount.description
            });

            if (subAccount.hasOwnProperty('subAccounts')) {
              subAccount.subAccounts.forEach(subSubAccount => {

                let accounts = [headAccount.account, subAccount.account, subSubAccount.account].join(':');

                this.flattedAccounts.push({
                  code: subSubAccount.code,
                  accounts: accounts,
                  description: subSubAccount.description
                });
              });
            }
          });
        }
      });
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok(account) {
    this.close({$value: account});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.accountLookup', [])
  .component('accountLookup', {
    template: require('./account-lookup.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: AccountLookupComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/account-lookup/account-lookup.component.js